import React from "react";
import { Route, Routes,useLocation } from "react-router-dom";
import "../index.css";
import Dashboard from "../pages/Dashboard";
import Header from '../components/Header';
import Footer from '../components/Footer';
import Profile from "../pages/Profile";
import Wallet from "../pages/Wallet";
import Orders from "../pages/Orders";
import Contact from "../pages/Contact";
import Address from "../pages/Address";
import DriverProfile from "../pages/DriverProfile"
import Guidance from "../pages/Guidance";
import Comment from "../pages/Comment";
import Stations from "../pages/Stations";
import Map from "../components/Map";
import GarbageCollection from "../pages/GarbageCollection";
import TimeSpan from "../pages/TimeSpan";
import FinalInfo from "../pages/FinalInfo";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MainAddress from "../pages/MainAddress";
import MainStations from "../pages/MainStations";
import InternalImage from "../pages/InternalImage";
import InternalVideo from "../pages/InternalVideo";


function Admin() {
const { pathname } = useLocation()

  return (
    <div>
      <Header />
      <div className="rgc-main">

        <Routes>
          <Route path='dashboard' element={<Dashboard />} />
          {/* <Route path='/*' element={<Wallet />} /> */}
          <Route path='wallet' element={<Wallet />} />
          <Route path='profile' element={<Profile />} />
          <Route path="stations" element={<Stations/>} />
          <Route  path="map" element={<Map/>}/>
          <Route  path="garbagecollection" element={<GarbageCollection/>}/>
          <Route path="timespan" element={<TimeSpan/>} />
          <Route path="finalinfo" element={<FinalInfo/>} />
          <Route path='mainaddress' element={<MainAddress />}/>
          <Route path='mainstations' element={<MainStations />}/>
          <Route path='orders' element={<Orders />}/>
          <Route path='contact' element={<Contact />}/>
          <Route path='address' element={<Address />}/>
          <Route path='driverprofile' element={<DriverProfile />}/>      
          <Route path='comment' element={<Comment />}/>
          <Route path='guidance' element={<Guidance />} />
          <Route path="internalimage" element={<InternalImage/>} >
            <Route path=":requestId" element={<InternalImage />} />
          </Route>
          <Route path="internalvideo" element={<InternalVideo/>}>
            <Route path=":requestId1" element={<InternalVideo />} />
          </Route>
        

        </Routes>
      </div>
      <div className="rgc-toast">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className="rgc-toast"
        />
      </div>
      {pathname === "/admin/dashboard" && 
      <Footer />
       }
    </div>

  );
}

export default Admin;
